import React, { useState, useEffect } from "react";
import { Page, Grid, Card, Table, Button } from "tabler-react";

import SiteWrapper from "../../SiteWrapper";
import * as productServices from '../../store/services/productServices';
import * as categoryServices from '../../store/services/categoryServices';
import { ROLE_ADMIN, ROLE_DEALER } from "../../store/types";
import { BACKENDURL } from "../../store/services/type";

function Products(props) {

    const [user] = useState((localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))) || {});

    const [ loading, setLoading ] = useState(false);
    const [ products, setProducts ] = useState([]);
    const [ categories, setCategories ] = useState([]);
    const [ selectedCategory, setSelectedCategory ] = useState(0);
    const [ search, setSearch ] = useState('');

    const [ totalPage, setTotalPage ] = useState(1);
    const [ currentPage, setCurrentPage ] = useState(1);

    useEffect(() => {
        categoryServices
            .getCategories()
            .then(( res ) => {
                const data = JSON.parse(res.data);
                setCategories(data?.data);
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        setLoading(true);
        productServices
            .getProducts(selectedCategory, currentPage, 1, search)
            .then(res => {
                const data = JSON.parse(res.data);
                setTotalPage(data?.data?.last_page);
                setCurrentPage(data?.data?.current_page);
                setProducts(data?.data?.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [ selectedCategory, currentPage, search ]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1);
    };

    const handleCategoryChange = (e) => {
        setSelectedCategory(e.target.value);
        setCurrentPage(1);
    };

    const getThumb = (images) => {
        if (!images || !images.length) return null;
        return `${BACKENDURL}storage/${images[0]}`;
    };

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header d-flex justify-content-between">
                    <h1 className="page-title">Products</h1>

                    <Button
                        className="btn-mm d-flex justify-content-center align-items-center"
                        onClick={() => props.history.push("/products/0")}
                    >
                        Add New
                        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 1.5V8.5" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                            <path d="M8 5H1" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                        </svg>
                    </Button>
                </div>
                <Grid.Row>
                    <Grid.Col>
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center" style={{ gap: '12px' }}>
                                <Card.Title>Products</Card.Title>

                                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                    {user.type !== "Dealer" && (
                                        <select
                                            className="form-control"
                                            onChange={handleCategoryChange}
                                            value={selectedCategory}
                                            style={{ width: 'auto' }}
                                        >
                                            <option value="">All Categories</option>
                                            {categories?.map((category, index) =>
                                                <option value={category.id} key={index}>{category.category}</option>
                                            )}
                                        </select>
                                    )}

                                    <input
                                        className="form-control"
                                        placeholder="Search name or SKU..."
                                        value={search}
                                        onChange={handleSearchChange}
                                        style={{ width: '200px' }}
                                    />
                                </div>
                            </Card.Header>

                            {products && products.length > 0 ? (
                                <Table
                                    cards={true}
                                    striped={true}
                                    responsive={true}
                                    className="table card-table table-vcenter datatable"
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.ColHeader style={{ width: '60px' }}></Table.ColHeader>
                                            <Table.ColHeader>Product</Table.ColHeader>
                                            <Table.ColHeader>SKU</Table.ColHeader>
                                            <Table.ColHeader>Internal ID</Table.ColHeader>
                                            <Table.ColHeader>Price</Table.ColHeader>
                                            <Table.ColHeader>Category</Table.ColHeader>
                                            {user?.type === ROLE_ADMIN && (
                                                <Table.ColHeader>Dealer</Table.ColHeader>
                                            )}
                                            <Table.ColHeader />
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {products.map((product, key) => (
                                            <Table.Row key={key}>
                                                <Table.Col>
                                                    {getThumb(product.images) ? (
                                                        <img
                                                            src={getThumb(product.images)}
                                                            alt=""
                                                            style={{ width: '55px', height: '55px', objectFit: 'cover', borderRadius: '6px', display: 'block' }}
                                                        />
                                                    ) : (
                                                        <div style={{ width: '55px', height: '55px', borderRadius: '6px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                                                        </div>
                                                    )}
                                                </Table.Col>
                                                <Table.Col>
                                                    { product?.product }
                                                    { product?.status === 'draft' && (
                                                        <span style={{ display: 'inline-block', marginLeft: 8, padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, backgroundColor: '#f0f0f0', color: '#6c757d' }}>Draft</span>
                                                    )}
                                                    { product?.variants?.length > 0 && (
                                                        <span style={{ display: 'inline-block', marginLeft: 8, padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, backgroundColor: '#f0fafa', color: '#2B9A99' }}>Variable</span>
                                                    )}
                                                </Table.Col>
                                                <Table.Col>{ product?.sku || '—' }</Table.Col>
                                                <Table.Col>{ product?.unique_id }</Table.Col>
                                                <Table.Col>{ product?.price }</Table.Col>
                                                <Table.Col>{ product?.category?.category }</Table.Col>
                                                {user?.type === ROLE_ADMIN && (
                                                    <Table.Col>
                                                        {
                                                            product?.dealer?.type === ROLE_DEALER &&
                                                            product?.dealer?.id &&
                                                            `${String(product?.user_id || "").padStart(4, '0')} - ${product?.dealer?.name || ""} ${product?.dealer?.last_name || ""}`
                                                        }
                                                    </Table.Col>
                                                )}
                                                <Table.Col>
                                                    <Button
                                                        color="secondary"
                                                        onClick={() => props.history.push("/products/view/" + product.id)}
                                                    >
                                                        View
                                                    </Button>
                                                </Table.Col>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            ) : (
                                <Card.Body className='align-items-center justify-content-center'>
                                    <h4 className="h4 mt-4 text-center" style={{ color: '#000', marginBottom: 20 }}>
                                        {search ? 'No results found' : 'No Products'}
                                    </h4>
                                    <div className="detail mb-5">
                                        {search ? `No products matching "${search}".` : 'No products created yet.'}
                                    </div>
                                </Card.Body>
                            )}

                            <Card.Footer className="justify-between">
                                <Button
                                    color="secondary"
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                >
                                    Prev
                                </Button>
                                <div>{`${currentPage} of ${totalPage}`}</div>
                                <Button
                                    color="secondary"
                                    onClick={() => setCurrentPage((prev) => prev + 1 > totalPage ? prev : prev + 1)}
                                >
                                    Next
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        </SiteWrapper>
    );
}

export default Products;
